export default __webpack_public_path__ + "static/media/homepage-banner-image_default.7320cd63.png";